import { render } from "./SortBuilder.vue?vue&type=template&id=74ef938c&scoped=true"
import script from "./SortBuilder.vue?vue&type=script&lang=js"
export * from "./SortBuilder.vue?vue&type=script&lang=js"

import "./SortBuilder.vue?vue&type=style&index=0&id=74ef938c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ef938c"]])

export default __exports__